import { IMarketingCloudUser, MarketingCloudUser } from '@ads/iam-library';
import Cookies from 'js-cookie';

/**
 * Generate request context authorization header from user object.
 * Used for API authentication across all environments (local, staging, production).
 * Also used by screenshot service to authenticate API calls via cookie.
 */
export function userToRequestContextAuthorizationHeader(user: IMarketingCloudUser): string {
  const requestContext = {
    principalId: user.getCognitoId(),
    integrationLatency: 0,
    roles: JSON.stringify(user.getRoles()),
    policies: JSON.stringify(user.getPolicies()),
    holdings: JSON.stringify(user.getHoldingIds()),
    businessEntities: JSON.stringify(user.getBusinessEntityIds()),
    allowedApplications: JSON.stringify(user.getAllowedApplications()),
  };
  return JSON.stringify(requestContext);
}

/**
 * Generate user object to check permissions.
 */
export function generateUserToCheck(user: IMarketingCloudUser | null): IMarketingCloudUser | null {
  if (user) {
    return user;
  }

  // Check if we have user context from cookie (screenshot service scenario)
  const userContextCookie = Cookies.get('user-context');
  if (!userContextCookie) {
    return null;
  }

  try {
    const authorizerData = JSON.parse(userContextCookie);

    const roles = JSON.parse(authorizerData.roles || '[]') as string[];
    const policies = JSON.parse(authorizerData.policies || '[]') as string[][];
    const holdings = JSON.parse(authorizerData.holdings || '[]') as number[];
    const businessEntities = JSON.parse(authorizerData.businessEntities || '[]') as number[];
    const allowedApplications = JSON.parse(authorizerData.allowedApplications || '[]') as string[];

    return new MarketingCloudUser({
      cognitoId: authorizerData.principalId || '',
      holdingIds: holdings,
      businessEntityIds: businessEntities,
      roles,
      policies,
      allowedApplications,
    });
  } catch (error) {
    console.error('Failed to parse user context from cookie', error);
    return null;
  }
}
